import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ArmTableComponent } from './arm-table.component';
import {MatTableModule} from '@angular/material/table';
import {FlexModule} from '@angular/flex-layout';
import {MaterialModule} from '../../material.module';
import {CursorPaginatorModule} from '../cursor-paginator/cursor-paginator.module';
import {ArmDirectivesModule} from '../../directives/arm-directives.module';
import {ResizeColumnDirective} from './resize-column.directive';

@NgModule({
  declarations: [
    ArmTableComponent,
    ResizeColumnDirective
  ],
  imports: [
    CommonModule,
    MatTableModule,
    FlexModule,
    MaterialModule,
    CursorPaginatorModule,
    ArmDirectivesModule
  ],
  exports: [
    ArmTableComponent
  ]
})
export class ArmTableModule { }
